import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/svg/icon-safari.svg'
import _imports_1 from '@/assets/svg/icon-chrome.svg'


const _hoisted_1 = { class: "browser-support-card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, [
  /*#__PURE__*/_createTextVNode(" It seems that this browser or its version doesn't support video chat functionality. Although you can join this room, other participants may not see or hear you. In contrast, you may not see or hear other connected participants, either. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" For a better experience, please continue with the suggested browser below and make sure that you update it to the latest version. ")
], -1)
const _hoisted_3 = { class: "row mt-5" }
const _hoisted_4 = {
  key: 0,
  class: "w-full"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, "For iPhone and iPad", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center mt-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "44",
    height: "44"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 flex items-center" }, "Safari")
], -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "w-full"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "For your device suggestion", -1)
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "flex items-center mt-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "44",
  height: "44"
}, null, -1)
const _hoisted_13 = { class: "ml-2 flex items-center" }

import useBrowserSupport from '@/composables/useBrowserSupport'
import { Engine } from '@/types/enums/room.enum'
import { PropType } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BrowserSupportCard',
  props: {
  roomUrl: {
    type: String,
    default: '',
  },
  engine: {
    type: String as PropType<Engine>,
    default: Engine.TWILIO,
  },
},
  setup(__props) {

const props = __props

const { isSuggestSafari, chromeLink } = useBrowserSupport(props.engine, props.roomUrl)

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_unref(isSuggestSafari))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("a", {
              href: _unref(chromeLink),
              target: "_blank"
            }, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, [
                  _createTextVNode("Google Chrome "),
                  _createVNode(_component_SvgIcon, {
                    class: "external-link-icon",
                    icon: "up-right",
                    "inherit-fill": true,
                    width: "20"
                  })
                ])
              ])
            ], 8, _hoisted_10)
          ]))
    ])
  ]))
}
}

})